import React, { useEffect, useState } from "react";
import axios from "axios";
import { useParams } from "react-router-dom";
import Header from "../components/Header";
import Footer from "../components/Footer";
import { FaShoppingCart, FaHeart } from "react-icons/fa";
import { useSwipeable } from "react-swipeable";
import { useCart } from "../context/cartContext";
import { useWishlist } from "../context/wishlistContext";
import ProductReviews from "../components/product/ProductReviews";
import Zoom from "react-medium-image-zoom";
import "react-medium-image-zoom/dist/styles.css";
import { useUser } from "../context/userContext";

const ProductDetails = () => {
  const { id } = useParams();
  const [product, setProduct] = useState(null);
  const [loading, setLoading] = useState(true);
  const [mainImage, setMainImage] = useState("");
  const [currentIndex, setCurrentIndex] = useState(0);
  const [thumbnailIndex, setThumbnailIndex] = useState(0);
  const { addToCart } = useCart();
  const { addToWishlist } = useWishlist();
  const [categoryAttributes, setCategoryAttributes] = useState([]);
  const [subcategoryAttributes, setSubcategoryAttributes] = useState([]);
  const [categoryAttributeValues, setCategoryAttributeValues] = useState({});
  const [subcategoryAttributeValues, setSubcategoryAttributeValues] = useState(
    {}
  );
  const [relatedProducts, setRelatedProducts] = useState([]);
  const [ratings, setRatings] = useState([]);
  const { user } = useUser();

  console.log("user",user);
  const fetchRelatedProducts = async (categoryId) => {
    try {
      const response = await axios.get(
        `https://api.theonlysale.com/api/product/category/${categoryId}`
      );
      const allProducts = response.data;
      const filteredProducts = allProducts.filter(
        (prod) => prod.id.toString() !== id.toString()
      );
      setRelatedProducts(filteredProducts);
    } catch (error) {
      console.error("Error fetching related products:", error);
    }
  };

  const fetchProductRating = async (categoryId) => {
    try {
      const response = await axios.get(
        `https://api.theonlysale.com/api/product-ratings/getByProduct/${id}`
      );
      setRatings(response.data);
    } catch (error) {
      console.error("Error fetching related products:", error);
    }
  };
  const fetchProductDetails = async () => {
    try {
      const response = await axios.get(
        `https://api.theonlysale.com/api/product/get/${id}`
      );
      const productData = response.data;

      let imagesArray = [];
      try {
        imagesArray = JSON.parse(productData.images);
      } catch (e) {
        console.error("Error parsing images array:", e);
      }

      const imageURIs = imagesArray.map(
        (image) =>
          `https://api.theonlysale.com/uploads/images/${image.split(/[\\/]/).pop()}`
      );

      setProduct({ ...productData, imageURIs });
      setMainImage(imageURIs[0]);

      await fetchRelatedProducts(productData.category_id);
      await fetchAttributes("category", productData.category_id);
      await fetchAttributes("subcategory", productData.subcategory_id);
      await fetchAttributeValues("category");
      await fetchAttributeValues("subcategory");

      setLoading(false);
    } catch (error) {
      console.error("Error fetching product details:", error);
      setLoading(false);
    }
  };

  useEffect(() => {
    const fetchProductData = async () => {
      await fetchProductDetails();
      await fetchProductRating();
    };
  
    fetchProductData();
  }, [id]);
  
  const fetchAttributes = async (type, id) => {
    const urlMap = {
      category: `https://api.theonlysale.com/api/category-attributes/getByCategoryId/${id}`,
      subcategory: `https://api.theonlysale.com/api/subcategory-attributes/getBySubcategoryId/${id}`,
    };

    try {
      const response = await axios.get(urlMap[type]);
      if (response.status === 200) {
        if (type === "category") {
          setCategoryAttributes(response.data);
        } else {
          setSubcategoryAttributes(response.data);
        }
      } else {
        console.error(`Failed to fetch ${type} attributes`);
      }
    } catch (error) {
      console.error(`Error fetching ${type} attributes:`, error);
    }
  };

  const fetchAttributeValues = async (type) => {
    const urlMap = {
      category: `https://api.theonlysale.com/api/product-category-attribute-values/getByProduct/${id}`,
      subcategory: `https://api.theonlysale.com/api/product-subcategory-attribute-values/getByProduct/${id}`,
    };
  
    try {
      const response = await axios.get(urlMap[type]);
      if (response.status === 200) {
        const values = {};
        response.data.forEach((attr) => {
          values[attr.attribute_id] = attr.value;
        });
  
        if (type === "category") {
          setCategoryAttributeValues(values);
        } else {
          setSubcategoryAttributeValues(values);
        }
      } else {
        console.error(`Failed to fetch ${type} attribute values`);
      }
    } catch (error) {
      console.error(`Error fetching ${type} attribute values:`, error);
    }
  };
  

  const handleSwipeLeft = () => {
    setCurrentIndex((prevIndex) =>
      Math.min(prevIndex + 1, relatedProducts.length - 1)
    );
  };

  const handleSwipeRight = () => {
    setCurrentIndex((prevIndex) => Math.max(prevIndex - 1, 0));
  };

  const handleThumbnailClick = (index) => {
    setCurrentIndex(index);
  };

  const handleThumbnailSwipe = (deltaX) => {
    if (deltaX > 0) {
      setThumbnailIndex((prevIndex) => Math.max(prevIndex - 1, 0));
    } else {
      setThumbnailIndex((prevIndex) =>
        Math.min(prevIndex + 1, product.imageURIs.length - 3)
      );
    }
  };

  const handleSwiped = (deltaX) => {
    if (deltaX > 0) {
      setCurrentIndex(
        (prevIndex) => (prevIndex + 1) % product.imageURIs.length
      );
    } else {
      setCurrentIndex(
        (prevIndex) =>
          (prevIndex - 1 + product.imageURIs.length) % product.imageURIs.length
      );
    }
  };

  useEffect(() => {
    if (product && product.imageURIs.length > 0) {
      setMainImage(product.imageURIs[currentIndex]);
    }
  }, [currentIndex, product]);

  const swipeHandlersMainImage = useSwipeable({
    onSwipedLeft: () => handleSwiped(1),
    onSwipedRight: () => handleSwiped(-1),
    preventDefaultTouchmoveEvent: true,
    trackMouse: true,
  });

  const swipeHandlersThumbnail = useSwipeable({
    onSwipedLeft: () => handleThumbnailSwipe(1),
    onSwipedRight: () => handleThumbnailSwipe(-1),
    preventDefaultTouchmoveEvent: true,
    trackMouse: true,
  });

  if (loading || !product) {
    return <p>Loading...</p>;
  }

  const handleAddToCart = (product) => {
    addToCart(product);
  };

  const handleAddToWishlist = (product) => {
    addToWishlist(product);
  };

  const combinedAttributes = [...categoryAttributes, ...subcategoryAttributes];
  const validAttributes = combinedAttributes.filter((attribute) => {
    const categoryValue = categoryAttributeValues[attribute.attribute_id];
    const subcategoryValue = subcategoryAttributeValues[attribute.attribute_id];
  
    return (
      (categoryValue && categoryValue !== "N/A") ||
      (subcategoryValue && subcategoryValue !== "N/A")
    );
  });
  
  const attributeTables = [];
  for (let i = 0; i < validAttributes.length; i += 4) {
    attributeTables.push(validAttributes.slice(i, i + 4));
  }
  
  
  const isOutOfStock = product.stock === 0;

  return (
    <>
      <Header />
      <section className="py-12 bg-white md:py-20 dark:bg-gray-900 antialiased">
  <div className="px-6 mx-auto max-w-7xl 2xl:px-0">
    <div className="lg:grid lg:grid-cols-2 lg:gap-12 xl:gap-20">
      <div className="max-w-lg mx-auto lg:max-w-md">
        <Zoom className="bg-black bg-opacity-80 rounded-lg shadow-md">
          <img
            style={{
              width: "100%",
              height: "400px",
              objectFit: "cover",
              cursor: "zoom-in",
              borderRadius: "8px",
            }}
            src={mainImage}
            alt={product.name}
            {...swipeHandlersMainImage}
          />
        </Zoom>
        <div className="flex justify-center mt-4 space-x-2">
          <div {...swipeHandlersThumbnail} className="flex space-x-2">
            {product.imageURIs
              .slice(thumbnailIndex, thumbnailIndex + 3)
              .map((image, index) => (
                <button
                  key={index + thumbnailIndex}
                  onClick={() => {
                    handleThumbnailClick(index + thumbnailIndex);
                    console.log(`Thumbnail ${index + thumbnailIndex} clicked`);
                  }}
                  className={`border-2 p-1 rounded ${
                    index + thumbnailIndex === currentIndex
                      ? "border-blue-500"
                      : "border-gray-300 hover:border-gray-500"
                  }`}
                >
                  <img
                    src={image}
                    alt={`Thumbnail ${index}`}
                    style={{ width: "80px", height: "80px", borderRadius: "4px" }}
                  />
                </button>
              ))}
          </div>
        </div>
      </div>

      <div className="mt-8 lg:mt-0">
        <h1 className="text-4xl font-bold text-gray-900 dark:text-white">
          {product.name}
        </h1>

        <div className="mt-4">
          {product.discount === 0 ? (
            <p className="text-2xl font-semibold text-gray-900 dark:text-white">
              ${product.price}
            </p>
          ) : (
            <>
              <p className="text-xl text-gray-600 dark:text-gray-400 line-through">
                ${product.price}
              </p>
              <p className="text-2xl font-semibold text-green-600 dark:text-green-400">
                ${product.final_price}
              </p>
            </>
          )}
        </div>

        <p className="text-lg text-gray-700 dark:text-gray-300 mt-4">
          {product.details}
        </p>

        <div className="mt-2">
          <p className="text-lg font-medium text-gray-800 dark:text-gray-400">
            Available: <span className="text-gray-900 dark:text-white">{product.stock}</span>
          </p>
        </div>

        <div className="flex space-x-4 mt-6">
          <button
            onClick={() => handleAddToCart(product)}
            className={`px-4 py-3 text-base font-semibold rounded-lg shadow-md transition-all ${
              isOutOfStock
                ? "bg-gray-400 cursor-not-allowed text-gray-700 dark:text-gray-500"
                : "bg-blue-600 text-white hover:bg-blue-700 dark:hover:bg-blue-800"
            }`}
            disabled={isOutOfStock}
          >
            <FaShoppingCart className="inline-block mr-2" />
            {isOutOfStock ? "Out of Stock" : "Add to Cart"}
          </button>

          <button
            onClick={() => handleAddToWishlist(product)}
            className="bg-red-600 text-white px-4 py-3 rounded-lg font-semibold shadow-md hover:bg-red-700 transition-all dark:hover:bg-red-800"
          >
            <FaHeart className="inline mr-2" />
            Add to Wishlist
          </button>
        </div>

        <div className="mt-8 grid grid-cols-1 md:grid-cols-2 gap-6">
          {attributeTables.map((table, index) => (
            <div key={index} className="w-full">
              <table className="table-auto w-full border-collapse rounded-lg overflow-hidden shadow-lg">
                <tbody>
                  {table.map((attribute, idx) => (
                    <tr
                      key={attribute.id}
                      className={`${
                        idx % 2 === 0
                          ? "bg-gray-50 dark:bg-gray-800"
                          : "bg-white dark:bg-gray-900"
                      } hover:bg-blue-50 dark:hover:bg-gray-700 transition-colors`}
                    >
                      <td className="border px-4 py-3 font-medium text-gray-800 dark:text-gray-200">
                        {attribute.name}
                      </td>
                      <td className="border px-4 py-3 text-gray-700 dark:text-gray-300">
                        {categoryAttributeValues[attribute.attribute_id] ||
                          subcategoryAttributeValues[attribute.attribute_id] ||
                          "N/A"}
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          ))}
        </div>
      </div>
    </div>
  </div>
</section>


        <ProductReviews
          averageRating={parseFloat(product.average_rating) || 0}
          productId={product.id}
        />
  
      <section className="py-8 bg-gray-50 dark:bg-gray-900">
        <div className="px-4 mx-auto 2xl:px-0 relative">
          <h2 className="text-xl font-semibold text-gray-900 sm:text-2xl dark:text-white">
            Related Products
          </h2>
          <div className="flex overflow-hidden space-x-6 mt-4">
            <div className="flex">
              {relatedProducts.length > 0 ? (
                relatedProducts.slice(0, 3).map((relatedProduct) => {
                  const relatedImages = JSON.parse(relatedProduct.images);
  
                  return (
                    <div
                      key={relatedProduct.id}
                      className="shrink-0 w-1/3 mr-5 bg-white dark:bg-gray-700 p-4 rounded-lg shadow"
                    >
                      <a href={`/product/${relatedProduct.id}`}>
                        <img
                          src={`https://api.theonlysale.com/uploads/images/${relatedImages[0]
                            ?.split(/[\\/]/)
                            .pop()}`}
                          alt={relatedProduct.name}
                          className="w-full h-32 object-cover rounded-t-lg"
                        />
                        <div className="mt-2">
                          <h3 className="text-sm font-medium text-gray-900 dark:text-white">
                            {relatedProduct.name}
                          </h3>
                          <p className="text-sm text-gray-500 dark:text-gray-400">
                            ${relatedProduct.final_price}
                          </p>
                        </div>
                      </a>
                    </div>
                  );
                })
              ) : (
                <p>No related products found.</p>
              )}
            </div>
          </div>
        </div>
      </section>
  
      <Footer />
    </>
  );
  
};

export default ProductDetails;
